// extracted by mini-css-extract-plugin
export default {"outputText":"CountdownRedirect_outputText__E43bg"};